import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'

import { isProduction } from '../../settings'
import { useEventTracker } from 'mmfintech-checkout-commons'
import { isMobileDevice, redirectToExternalUrl } from 'mmfintech-commons'

import { PreviewPix } from './PreviewPix'
import { PreviewFrame } from './PreviewFrame'
import { PreviewCrypto } from './PreviewCrypto'
import { PreviewMessage } from './PreviewMessage'
import { PreviewBankwire } from './PreviewBankwire'
import { PreviewInstructions } from './PreviewInstructions'

export const DepositResult = ({ response, session, sessionId }) => {
  const { result, resultType, status, processingAmount, processingCurrency } = response || {}

  const history = useHistory()

  const { trackEvent } = useEventTracker()

  const redirectToProvider = useCallback(() => {
    trackEvent(sessionId, 'redirected_to_provider')
    redirectToExternalUrl(result)
    // window.open(result, '_self', 'noopener,noreferrer')
  }, [trackEvent, sessionId])

  if (status === 'FAILED') {
    history.push('/fail')
    return
  }

  switch (resultType) {
    // case 'INTERNAL_EXECUTION':
    // case 'CRYPTO_ADDRESS_DETAILS':
    // case 'CHECKOUT_CRYPTO_ADDRESS_DETAILS':

    case 'INSTRUCTIONS':
      return <PreviewInstructions sessionId={sessionId} result={{ ...result, processingAmount, processingCurrency }} />

    case 'BANKWIRE_DETAILS':
      return <PreviewBankwire result={result} session={session} sessionId={sessionId} />

    case 'CHECKOUT_CRYPTO_ADDRESS_DETAILS':
      return <PreviewCrypto sessionId={sessionId} data={{ ...result, ...{ processingAmount } }} />

    case 'MESSAGE':
      return <PreviewMessage result={result} />

    case 'REDIRECT_URL':
      redirectToProvider()
      break

    case 'QR_CODE':
      return <PreviewPix value={result} />

    case 'IFRAME_URL':
      if (isMobileDevice()) {
        redirectToProvider()
      } else {
        trackEvent(sessionId, 'open_provider_in_frame')
        return <PreviewFrame result={result} />
      }
      break

    default:
      if (!isProduction && resultType) {
        console.log(`DepositResult: Unsupported result type ${resultType}`)
      }
  }

  return null
}
